// Đường dẫn Gom Đơn trên web ShopTrack — module THUẦN (không import gì), test ở tests/unit/web-gomdon-nav.test.ts.
// Chỉ có MỘT trang: /inbox (và /inbox/:id). /comments, /chat-channels là đường cũ, chuyển về /inbox (main.tsx) nhưng vẫn
// tính là đường Gom Đơn (quyền nhân viên, chế độ Bán hàng). Chỉ có nghĩa khi engine mở cho đơn vị đang mở (access.ts).

export const GOMDON_PATHS = ['/inbox', '/comments', '/chat-channels'] as const

export function isGomdonPath(path: string): boolean {
  return GOMDON_PATHS.some((p) => path === p || path.startsWith(p + '/'))
}

/**
 * Đích của đường cũ (trước khi gộp thành một trang), giữ mọi tham số đang có:
 *  · /comments, /comments/:id → /inbox?kind=comment (giữ id hợp lệ);
 *  · /chat-channels → /inbox?connect=1 (mở hộp Kết nối) — kết quả đăng nhập Facebook / Instagram (?connected / ?failed /
 *    ?fb_error / ?ig_error) của lần đăng nhập bắt đầu trước khi đổi vẫn được báo.
 */
export function legacyGomdonTarget(from: 'comments' | 'chat-channels', id: string | undefined, search: string): string {
  const params = new URLSearchParams(search)
  if (from === 'chat-channels') {
    params.set('connect', '1')
    return `/inbox?${params}`
  }
  params.set('kind', 'comment')
  const n = Number(id)
  return `/inbox${id && Number.isInteger(n) && n > 0 ? `/${n}` : ''}?${params}`
}

/** Bỏ các mục Gom Đơn khỏi một menu — đơn vị chưa dùng được Gom Đơn thấy menu y như trước khi có Gom Đơn */
export function withoutGomdon<T extends { to: string }>(items: readonly T[]): T[] {
  return items.filter((item) => !isGomdonPath(item.to))
}
